import { render, staticRenderFns } from "./share_foot.vue?vue&type=template&id=3e53b74c&scoped=true"
import script from "./share_foot.vue?vue&type=script&lang=js"
export * from "./share_foot.vue?vue&type=script&lang=js"
import style0 from "./share_foot.vue?vue&type=style&index=0&id=3e53b74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e53b74c",
  null
  
)

export default component.exports